import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const navItems = [
  { name: 'HOME', path: '/', id: 'home' },
  { name: 'SERVICES', path: '/#services', id: 'services' },
  { name: 'ABOUT', path: '/#about', id: 'about' },
  { name: 'OUR STORY', path: '/#story', id: 'story' },
  { name: 'CONTACT', path: '/#contact', id: 'contact' },
];

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (path, id) => {
    setIsOpen(false);
    
    if (path.startsWith('/#')) {
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      } else {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(path);
      window.scrollTo(0, 0);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#020617]/95 backdrop-blur-xl border-b border-white/5' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-20">
          {/* Logo - Premium Gold & White */}
          <button
            onClick={() => handleNavClick('/', 'home')}
            className="flex items-center gap-4 group"
          >
            {/* Premium Logo Mark */}
            <div className="relative w-12 h-12 border border-[#D4AF37] flex items-center justify-center group-hover:border-white transition-colors duration-300">
              <span className="font-serif text-2xl text-[#D4AF37] group-hover:text-white transition-colors duration-300">R</span>
              <div className="absolute inset-0 border border-[#D4AF37] translate-x-1 translate-y-1 -z-10 opacity-30" />
            </div>
            <div>
              <div className="text-white font-serif text-xl tracking-tight">Rosevilla Group</div>
              <div className="text-[#94A3B8] text-[10px] uppercase tracking-[0.2em] font-light">Investment Holdings</div>
            </div>
          </button>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-12">
            {navItems.map((item) => (
              <button
                key={item.name}
                onClick={() => handleNavClick(item.path, item.id)}
                className="text-[#94A3B8] hover:text-white text-xs uppercase tracking-[0.2em] font-light transition-all duration-300 hover:tracking-[0.25em]"
              >
                {item.name}
              </button>
            ))}
          </div>

          {/* CTA Button Desktop */}
          <button
            onClick={() => handleNavClick('/#contact', 'contact')}
            className="hidden lg:block bg-[#D4AF37] hover:bg-[#F8FAFC] text-[#020617] px-8 py-3 font-serif tracking-wide transition-all duration-300"
          >
            Get in Touch
          </button>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-[#D4AF37] hover:text-white transition-colors p-2"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="lg:hidden bg-[#020617]/98 backdrop-blur-xl border-t border-white/10">
          <div className="max-w-7xl mx-auto px-6 py-8 space-y-6">
            {navItems.map((item) => (
              <button
                key={item.name}
                onClick={() => handleNavClick(item.path, item.id)}
                className="block w-full text-left text-[#94A3B8] hover:text-white text-sm uppercase tracking-[0.2em] font-light py-3 border-b border-white/10 transition-colors"
              >
                {item.name}
              </button>
            ))}
            <button
              onClick={() => handleNavClick('/#contact', 'contact')}
              className="w-full bg-[#D4AF37] hover:bg-[#F8FAFC] text-[#020617] px-8 py-4 font-serif tracking-wide transition-all duration-300 mt-4"
            >
              Get in Touch
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
